<router-outlet></router-outlet>
<app-spinner-loader></app-spinner-loader>